import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger)

$.fn.stairsEffect = function() {
  let self = this
  self.cols = self.find('.col')

  self.init_offset = function() {
    // const tl = gsap.timeline({
    //   scrollTrigger: {
    //     trigger: self.cols.last(),
    //     start: "top bottom",
    //     end: "bottom top",
    //     scrub: true
    //   }
    // });
    // tl.fromTo(self.cols.last(), { y: 150 }, { y: 0, duration: 0.5, ease: "none" })
    // .fromTo(self.cols.last(), { y: 0 }, { y: -150, duration: 0.5, ease: "none" });

    ScrollTrigger.matchMedia({
      "(min-width: 768px)": function() {
        if (self.cols.length === 2) {
          const tl = gsap.timeline({
            scrollTrigger: {
              trigger: self.cols.last(),
              start: "top bottom",
              end: "bottom top",
              scrub: true
            }
          });
          tl.fromTo(self.cols.last(), { y: 150 }, { y: 0, duration: 0.5, ease: "none" })
          .fromTo(self.cols.last(), { y: 0 }, { y: -150, duration: 0.5, ease: "none" });
        } else if (self.cols.length === 3) {
          const tlMiddle = gsap.timeline({
            scrollTrigger: {
              trigger: self.cols.eq(1),
              start: "top bottom",
              end: "bottom top",
              scrub: true
            }
          });
          tlMiddle.fromTo(self.cols.eq(1), { y: 100 }, { y: 0, duration: 0.5, ease: "none" })
          .fromTo(self.cols.eq(1), { y: 0 }, { y: -100, duration: 0.5, ease: "none" });

          const tlRight = gsap.timeline({
            scrollTrigger: {
              trigger: self.cols.last(),
              start: "top bottom",
              end: "bottom top",
              scrub: true
            }
          });
          tlRight.fromTo(self.cols.last(), { y: 150 }, { y: 0, duration: 0.5, ease: "none" })
          .fromTo(self.cols.last(), { y: 0 }, { y: -150, duration: 0.5, ease: "none" });
        }
      }
    });
  }

  return function() {
    self.init_offset()
    return self
  }()
}
